module.exports = __webpack_public_path__ + "img/bg.b6804274.jpg";